import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import { BONUS_LEVELS, BONUS_AMOUNTS } from "constants";

import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";

import padlockIcon from "assets/img/icons/padlock-icon.svg";
import padlockGreyIcon from "assets/img/icons/padlock-icon-grey.svg";
import referralsQualifiedGreyIcon from "assets/img/icons/referral-qualified-icon-grey.svg";
import referralsQualifiedIcon from "assets/img/icons/referral-qualified-icon.svg";
import dollarCashBonusIcon from "assets/img/icons/dollar-icon-cash-bonus.svg";
import cashGreenIcon from "assets/img/icons/cash-icon-green.svg";

const CashBonusBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const DollarIcon = styled.div`
  display: inline-block;
  padding-right: 4px;

  transform: translateY(4.5px);

  width: 27px;
  min-width: 27px;
`;

const Text = styled.div`
  line-height: 125%;
`;

const CashBonusSummary = styled.div`
  width: 100%;
  padding: 15px 20px;
  margin-top: 18px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const MonthBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Month = styled.div`
  font-size: 18px;
`;

const Badge = styled.div`
  height: 22px;
  padding: 0 12px;

  font-size: 13px;

  border-radius: 11px;
  background: ${css.POSITIVE_GREEN};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const BarLines = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 7px;
`;

const BarLine = styled.div`
  width: 100%;

  color: ${(props) => (props.grey ? "#9F9F9F" : "#fff")};

  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: ${globalConstants.switchMobile}) {
    gap: 12px;
  }
`;

const BonusBox = styled.div`
  min-width: 104px;

  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: ${globalConstants.switchMobile}) {
    min-width: 94px;
  }
`;

const CounterBox = styled.div`
  min-width: 80px;

  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: ${globalConstants.switchMobile}) {
    min-width: 58px;
  }
`;

const IconTextBoxIcon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
`;

const IconTextBoxText = styled.div`
  font-weight: 500;
  color: ${(props) => (props.green ? css.BRAND_GREEN : "inherit")};

  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: ${globalConstants.switchMobile}) {
    font-size: 14px;
  }
`;

const Bar = styled.div`
  position: relative;
  height: 20px;

  overflow: hidden;

  border-radius: 10px;
  background: ${(props) => (props.grey ? "#617489" : css.BRAND_INDIGO)};

  flex: 1;
`;

const BarProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${(props) => props.progresspercent}%;
  box-sizing: border-box;

  background: ${css.BRAND_GREEN};
`;

const ButtonWrap = styled.div`
  margin-top: 18px;

  display: flex;
`;

const CashBonusSmallInfo = styled.div`
  margin-top: 10px;

  font-size: 13px;
  color: ${css.TEXT_GREY};
  line-height: 125%;
`;

export default ({ data }) => {
  const navigate = useNavigate();

  const { monthInProgress, thisMonthQualified } = data.cashBonusData;

  // const { monthInProgress } = data.cashBonusData;
  // const thisMonthQualified = 0;

  // const bonusLevels = [10, 30, 70, 150, 310, 630];
  // const bonusAmounts = [1, 2, 5, 15, 60, 320];

  let activeLevel = 1;

  for (let i = 0; i <= BONUS_LEVELS.length; i++) {
    if (thisMonthQualified >= BONUS_LEVELS[i]) {
      activeLevel++;
    }
  }

  const barLines = BONUS_AMOUNTS.map((amount, index) => {
    const levelStart = index > 0 ? BONUS_LEVELS[index - 1] : 0;

    const levelReferrals =
      index > 0 ? BONUS_LEVELS[index] - levelStart : BONUS_LEVELS[index];

    const lineNumber = index + 1;

    const greyed = lineNumber > activeLevel;

    let progress = 0;
    let progressPercent = 0;
    let unlocked = false;

    if (lineNumber < activeLevel) {
      unlocked = true;
      progress = levelReferrals;
      progressPercent = 100;
    }

    if (lineNumber === activeLevel) {
      progress = thisMonthQualified - levelStart;
      progressPercent =
        (100 / (BONUS_LEVELS[index] - levelStart)) *
        (thisMonthQualified - levelStart);
    }

    return (
      <BarLine grey={greyed ? 1 : 0} key={lineNumber}>
        <BonusBox>
          <IconTextBoxIcon>
            {!unlocked && (
              <img
                src={greyed ? padlockGreyIcon : padlockIcon}
                style={{ width: "100%" }}
              />
            )}
            {unlocked && (
              <img
                src={cashGreenIcon}
                style={{ width: "100%", paddingTop: "1px" }}
              />
            )}
          </IconTextBoxIcon>
          <IconTextBoxText green={unlocked ? 1 : 0}>
            ${amount} Bonus
          </IconTextBoxText>
        </BonusBox>
        <CounterBox>
          <IconTextBoxIcon>
            <img
              src={greyed ? referralsQualifiedGreyIcon : referralsQualifiedIcon}
              style={{ width: "100%" }}
            />
          </IconTextBoxIcon>
          <IconTextBoxText>
            {progress}/{levelReferrals}
          </IconTextBoxText>
        </CounterBox>
        <Bar grey={greyed ? 1 : 0}>
          <BarProgress progresspercent={progressPercent} />
        </Bar>
      </BarLine>
    );
  });

  return (
    <CashBonusBox>
      <BoxTitle>
        <DollarIcon>
          <img src={dollarCashBonusIcon} style={{ width: "100%" }} />
        </DollarIcon>
        Earn Money With Our Referral Program
      </BoxTitle>
      <Text>
        Refer enough users in one month and receive a generous bonus. Unlock
        bonuses one by one and earn more than $1200 per month.
      </Text>
      <CashBonusSummary>
        <MonthBox>
          <Month>{monthInProgress}</Month>
          <Badge>In progress</Badge>
        </MonthBox>
        <BarLines>{barLines}</BarLines>
      </CashBonusSummary>
      <ButtonWrap>
        <ButtonPrimarySmall onClick={() => navigate("/settings")}>
          Payout Setup
        </ButtonPrimarySmall>
      </ButtonWrap>
      <CashBonusSmallInfo>
        * Only qualified referrals count towards the calculation of the cash
        bonus. A user must find a total of at least 1,000 coins while browsing
        posts on the Discover page to become a qualified referral.
      </CashBonusSmallInfo>
    </CashBonusBox>
  );
};
